var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'cmi-cont' + (_vm.selected ? ' cmi-selected' : '')},[_c('img',{staticClass:"cmi-img",attrs:{"src":_vm.centro_logo},on:{"error":_vm.failed_logo}}),_c('div',{staticClass:"cmi-name-cont"},[_c('div',{staticClass:"cmi-indent"},[_vm._v(_vm._s(_vm.indent))]),_c('div',{staticClass:"cmi-name"},[_vm._v(_vm._s(_vm.centro.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }